import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { FsessionService } from "../session/fsession.service";
import { MunicipalityTokenService } from "./municipality-token.service";
import { DatabaseService } from "../database/database.service";
import { TokenRefreshService } from "./token-refresh.service";
import { updateTokensAndRefresh } from "./token-utils";

export const municipalityTokenResolver: ResolveFn<boolean> = async () => {
  const fseService = inject(FsessionService);
  const databaseService = inject(DatabaseService);
  const municipalityTokenService = inject(MunicipalityTokenService);
  const tokenRefreshService = inject(TokenRefreshService);

  const municipalityToken = fseService.optenerValor("clientToken", "municipality");
  if (!municipalityToken || typeof municipalityToken !== "string") {
    return false;
  }


  try {
    await municipalityTokenService.verifyAndStoreToken(municipalityToken);

    if (municipalityTokenService.getStatus() === 'expired') {
      databaseService.municipalityRefreshToken().subscribe({
        next: ({ accessToken, refreshToken }) => {
          Promise.all([
            municipalityTokenService.verifyAndStoreToken(accessToken),
            municipalityTokenService.verifyToken(refreshToken),
          ]).then(() => {
            updateTokensAndRefresh(
              fseService,
              municipalityTokenService,
              tokenRefreshService,
              accessToken,
              refreshToken,
              'schedule'
            );
          });
        }
      })
    }

  } catch {
    return false;
  }

  return true;
};
